import {createContext, useState, useContext, ReactNode} from 'react';
import {AuthProfile} from "@/api/types.ts";

interface ProfileContext {
  authProfile: AuthProfile | undefined;
  setAuthProfile: (profile: AuthProfile | undefined) => void;
}

const AuthProfileContext = createContext<ProfileContext|undefined>(undefined);

export const AuthProfileProvider = ({ children }:{children: ReactNode}) => {
  const [authProfile, setAuthProfile] = useState<AuthProfile | undefined>(undefined);

  return (
    <AuthProfileContext.Provider value={{ authProfile, setAuthProfile }}>
      {children}
    </AuthProfileContext.Provider>
  );
};

export const useAuthProfile = (): ProfileContext => {
  const context = useContext(AuthProfileContext);

  if (context === undefined) {
    throw new Error('useAuthProfile must be used within a AuthProfileProvider');
  }

  return context;
};
